import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';

export class LocationState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public locationName: string;
  public locationGuid: string;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.locationName = null;
    this.locationGuid = null;
  }
}
